import React, { Component } from 'react';
import _ from 'lodash';
var Api = require('./Config');

export default class JourneySwitcher extends Component {
  constructor(props) {
    super(props);
    this.state = { filter: '', orgiJourneys: [] };
    this.state.journeys = [];
  }

  componentDidMount() {
    Api.getSwitchableJourneys(this.props.jid)
      .then((journeys) => {
        this.setState({ journeys: journeys, orgiJourneys: journeys });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  doFilter() {
    this.state.journeys = _.filter(this.state.orgiJourneys, (data) => {
      return data.journey_name.toLowerCase().indexOf(this.state.filter.toLowerCase()) != -1;
    });
  }

  render() {
    return (
      <div className="modal show">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                onClick={() => {
                  this.props.onClose();
                }}
                className="close"
                data-dismiss="modal"
              >
                &times;
              </button>
              <h4 className="modal-title">Select Journey to switch</h4>
            </div>
            <div className="modal-body">
              {this.state.journeys.length > 1 && (
                <div>
                  <input
                    value={this.state.filter}
                    onChange={(e) => {
                      this.state.filter = e.target.value;
                      this.setState({ filter: e.target.value });
                      this.doFilter();
                    }}
                    type="text"
                    className="form-control"
                    placeholder="search"
                  />
                </div>
              )}
              <div style={{ maxHeight: 400, overflow: 'auto' }}>
                <table className="table table-stripped">
                  <thead>
                    <tr>
                      <th>Journeys</th>
                    </tr>
                  </thead>
                  <tbody>
                    {_.map(this.state.journeys, (a, index) => {
                      return (
                        <tr key={index}>
                          <td
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              this.props.onSelect(a);
                            }}
                          >
                            {a.journey_name}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button
                onClick={() => {
                  this.props.onClose();
                }}
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
